/** F606 Announcements page — push notifications & broadcasts. */
import { Megaphone } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606AnnouncementsPage() {
  return (
    <F606DataPage
      entity="announcements"
      titleAr="الإعلانات"
      titleEn="Announcements"
      icon={Megaphone}
      emptyIcon={Megaphone}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        {
          key: 'title',
          ar: 'العنوان', en: 'Title',
          render: (r) => (
            <div>
              <div className="font-bold text-white">{r.title || '—'}</div>
              {r.body && <div className="text-[10px] text-white/50 truncate max-w-md">{String(r.body).slice(0, 80)}</div>}
            </div>
          ),
        },
        { key: 'audience', ar: 'الجمهور', en: 'Audience', render: (r) => r.audience || r.target || 'all', className: 'w-24 text-center text-[10px] text-white/60' },
        { key: 'sent_count', ar: 'الإرسال', en: 'Sent', render: (r) => r.sent_count ?? r.recipients_count ?? '—', className: 'w-20 text-center' },
        { key: 'opened_count', ar: 'الفتح', en: 'Opened', render: (r) => r.opened_count ?? '—', className: 'w-20 text-center' },
        {
          key: 'sent_at',
          ar: 'أُرسل في', en: 'Sent at',
          render: (r) => r.sent_at || r.created_at ? new Date(r.sent_at || r.created_at).toLocaleString() : '—',
          className: 'w-40 text-[11px] text-white/60',
        },
      ]}
    />
  );
}
